import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import api from "../../services/api";

const CreatePassword = () => {
  const history = useHistory();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Senha deve ter no mínimo 8 caracteres");
    if (password !== confirm) return setError("Senhas não conferem");
    setLoading(true);
    try {
      await api.post("/auth/create-password", { token, password, password_confirmation: confirm });
      setSuccess(true);
      setTimeout(() => history.push("/login"), 3000);
    } catch (err) {
      setError(err?.response?.data?.error || "Erro ao criar senha. Tente novamente.");
    }
    setLoading(false);
  };

  const inputStyle = { width: "100%", border: "1px solid #E2E8F0", borderRadius: 10, padding: "12px 14px", fontSize: "0.9rem", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
  const labelStyle = { display: "block", fontSize: "0.82rem", fontWeight: 600, color: "#374151", marginBottom: 6 };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#080E1C,#0F1B35)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',system-ui,sans-serif", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "48px 40px", maxWidth: 440, width: "100%", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: "2rem", marginBottom: 10 }}>⚡</div>
          <h1 style={{ fontWeight: 800, fontSize: "1.4rem", color: "#0F172A", marginBottom: 6 }}>Criar sua senha</h1>
          <p style={{ color: "#64748B", fontSize: "0.88rem" }}>Defina uma senha segura para acessar a Korax.</p>
        </div>

        {success ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>✅</div>
            <div style={{ fontWeight: 700, fontSize: "1.1rem", color: "#16A34A", marginBottom: 8 }}>Senha criada!</div>
            <div style={{ color: "#64748B", fontSize: "0.88rem" }}>Redirecionando para o login...</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div>
              <label style={labelStyle}>Nova senha</label>
              <input type="password" style={inputStyle} value={password} onChange={e => setPassword(e.target.value)} placeholder="Mínimo 8 caracteres" required />
            </div>
            <div>
              <label style={labelStyle}>Confirmar senha</label>
              <input type="password" style={inputStyle} value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repita sua senha" required />
            </div>
            {error && <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: 8, padding: "10px 14px", fontSize: "0.82rem", color: "#DC2626" }}>{error}</div>}
            <button type="submit" disabled={loading} style={{ background: "#1D4ED8", color: "#fff", border: "none", borderRadius: 10, padding: "13px", fontWeight: 700, fontSize: "0.9rem", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
              {loading ? "Criando..." : "Criar senha e entrar →"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
export default CreatePassword;
